// import React, { useState, useEffect } from "react";
// import {
//   IonCard,
//   IonCardHeader,
//   IonCardTitle,
//   IonCardSubtitle,
//   IonCardContent,
//   IonImg,
//   IonText,
// } from "@ionic/react";
// import { SERVER_URL } from "../../api/client";

// const LinkPreview = ({ url }) => {
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     if (!url) return;
//     fetch(`${SERVER_URL}/api/preview?url=${encodeURIComponent(url)}`)
//       .then((res) => res.json())
//       .then(setData)
//       .catch(console.error);
//   }, [url]);

//   if (!data) return null;

//   return (
//     <IonCard
//       style={{
//         borderRadius: "14px",
//         overflow: "hidden",
//         boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//       }}
//       className="ion-padding"
//     >
//       {data.image && (
//         <IonImg
//           src={`${SERVER_URL}/api/proxy-image?url=${encodeURIComponent(
//             data.image
//           )}`}
//           alt={data.title}
//           onError={(e) => {
//             e.target.src = "/assets/link-placeholder.png";
//           }}
//           style={{
//             width: "100%",
//             height: "200px",
//             objectFit: "cover",
//             marginBottom: "12px",
//           }}
//         />
//       )}

//       <IonCardHeader>
//         <IonCardTitle style={{ fontSize: "1rem", fontWeight: "600" }}>
//           {data.title}
//         </IonCardTitle>
//         {data.siteName && (
//           <IonCardSubtitle style={{ color: "#6b7280", fontSize: "0.85rem" }}>
//             {data.siteName}
//           </IonCardSubtitle>
//         )}
//       </IonCardHeader>

//       <IonCardContent
//         className="ion-no-padding"
//         style={{
//           marginTop: "8px",
//           height: "100px",
//           minHeight: "100px",
//           overflow: "hidden",
//         }}
//       >
//         <IonText color="medium" style={{ fontSize: "0.9rem" }}>
//           {data.description?.length > 100
//             ? data.description.slice(0, 100) + "..."
//             : data.description}
//         </IonText>
//       </IonCardContent>
//     </IonCard>
//   );
// };

// export default LinkPreview;
// import React, { useState, useEffect } from "react";
// import {
//   IonCard,
//   IonCardHeader,
//   IonCardTitle,
//   IonCardSubtitle,
//   IonCardContent,
//   IonImg,
//   IonText,
//   IonSkeletonText,
// } from "@ionic/react";
// import { SERVER_URL } from "../../api/client";

// const LinkPreview = ({ url }) => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (!url) return;

//     setLoading(true);
//     fetch(`${SERVER_URL}/api/preview?url=${encodeURIComponent(url)}`)
//       .then((res) => res.json())
//       .then((resData) => {
//         setData(resData);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error(err);
//         setLoading(false);
//       });
//   }, [url]);

//   return (
//     <IonCard
//       style={{
//         borderRadius: "14px",
//         overflow: "hidden",
//         boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//         maxWidth: "600px",
//         margin: "auto",
//         width: "100%",
//       }}
//       className="ion-padding"
//     >
//       {/* === IMAGE SECTION === */}
//       {loading ? (
//         <IonSkeletonText
//           animated
//           style={{
//             width: "100%",
//             height: "200px",
//             borderRadius: "8px",
//             marginBottom: "12px",
//           }}
//         />
//       ) : data?.image ? (
//         <IonImg
//           src={`${SERVER_URL}/api/proxy-image?url=${encodeURIComponent(
//             data.image
//           )}`}
//           alt={data.title}
//           onError={(e) => {
//             e.target.src = "/assets/link-placeholder.png";
//           }}
//           style={{
//             width: "100%",
//             height: "200px",
//             objectFit: "cover",
//             marginBottom: "12px",
//           }}
//         />
//       ) : null}

//       <IonCardHeader>
//         {loading ? (
//           <>
//             <IonSkeletonText
//               animated
//               style={{ width: "70%", height: "16px", marginBottom: "8px" }}
//             />
//             <IonSkeletonText
//               animated
//               style={{ width: "40%", height: "12px", marginBottom: "4px" }}
//             />
//           </>
//         ) : (
//           <>
//             <IonCardTitle style={{ fontSize: "1rem", fontWeight: "600" }}>
//               {data?.title}
//             </IonCardTitle>
//             {data?.siteName && (
//               <IonCardSubtitle
//                 style={{ color: "#6b7280", fontSize: "0.85rem" }}
//               >
//                 {data.siteName}
//               </IonCardSubtitle>
//             )}
//           </>
//         )}
//       </IonCardHeader>

//       <IonCardContent
//         className="ion-no-padding"
//         style={{
//           marginTop: "8px",
//           height: "100px",
//           minHeight: "100px",
//           overflow: "hidden",
//         }}
//       >
//         {loading ? (
//           <>
//             <IonSkeletonText
//               animated
//               style={{ width: "90%", height: "12px", marginBottom: "6px" }}
//             />
//             <IonSkeletonText
//               animated
//               style={{ width: "80%", height: "12px", marginBottom: "6px" }}
//             />
//             <IonSkeletonText
//               animated
//               style={{ width: "70%", height: "12px", marginBottom: "6px" }}
//             />
//           </>
//         ) : (
//           <IonText color="medium" style={{ fontSize: "0.9rem" }}>
//             {data?.description?.length > 100
//               ? data.description.slice(0, 100) + "..."
//               : data?.description}
//           </IonText>
//         )}
//       </IonCardContent>
//     </IonCard>
//   );
// };

// export default LinkPreview;
import React, { useEffect, useState } from "react";

function LinkPreview({ url }) {
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url) return;

    const fetchPreview = async () => {
      try {
        // ✅ Use Microlink API for stable metadata
        const res = await fetch(
          `https://api.microlink.io?url=${encodeURIComponent(url)}`
        );
        const data = await res.json();

        if (data.status === "success") {
          setPreview(data.data);
        } else {
          throw new Error("Failed to fetch preview");
        }
      } catch (err) {
        console.error("Preview fetch failed:", err.message);
        setError(err.message);
      }
    };

    fetchPreview();
  }, [url]);

  if (error || !preview) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="link-preview"
      style={{
        display: "flex",
        flexDirection: "column",
        textDecoration: "none",
        border: "1px solid #ddd",
        borderRadius: "8px",
        overflow: "hidden",
        marginTop: "8px",
      }}
    >
      {preview.image?.url && (
        <img
          src={preview.image.url}
          alt={preview.title || "Preview"}
          style={{
            width: "100%",
            maxHeight: "200px",
            objectFit: "contain",
          }}
        />
      )}
      <div style={{ padding: "8px" }}>
        <strong
          style={{ display: "block", marginBottom: "4px", color: "#000" }}
        >
          {preview.title || url}
        </strong>
        <p style={{ fontSize: "0.9rem", color: "#555" }}>
          {preview.description}
        </p>
        <small style={{ color: "#888" }}>{preview.publisher}</small>
      </div>
    </a>
  );
}

export default LinkPreview;
